import type { RosterRow } from '../Roster/rosterRows';

export type SchoolRow = {
  name: string;
  students: number;
  newcomers: number;
  ltels: number;
};

export const EM_DASH = '—';

export function buildSchoolRows(rows: RosterRow[]): SchoolRow[] {
  const byKey = new Map<string, SchoolRow>();
  for (const row of rows) {
    if (row.school === EM_DASH) continue;
    const key = row.school.trim().toLowerCase();
    const entry =
      byKey.get(key) ?? { name: row.school, students: 0, newcomers: 0, ltels: 0 };
    entry.students += 1;
    if (row.cohorts.includes('newcomer')) entry.newcomers += 1;
    if (row.cohorts.includes('ltel')) entry.ltels += 1;
    byKey.set(key, entry);
  }
  return [...byKey.values()];
}

export function sortSchoolsByName(rows: SchoolRow[]): SchoolRow[] {
  return [...rows].sort((a, b) => a.name.localeCompare(b.name));
}

export function filterSchools(rows: SchoolRow[], query: string): SchoolRow[] {
  const q = query.trim().toLowerCase();
  if (q === '') return rows;
  return rows.filter((row) => row.name.toLowerCase().includes(q));
}
